const startedAt = typeof performance !== "undefined" ? performance.now() : Date.now();
const events = [];
const once = new Set();

const elapsed = () => Math.round((typeof performance !== "undefined" ? performance.now() : Date.now()) - startedAt);

export function markPerformance(stage, details = {}, { onlyOnce = false } = {}) {
  if (onlyOnce && once.has(stage)) return;
  if (onlyOnce) once.add(stage);
  const event = { stage, elapsedMs: elapsed(), ...details };
  events.push(event);
  console.info("[ZunoPerformance]", event);
  return event;
}

export function startPerformanceSpan(stage, details = {}) {
  const started = elapsed();
  markPerformance(`${stage}_START`, details);
  return (result = {}) => {
    const finished = elapsed();
    return markPerformance(`${stage}_DONE`, { ...result, durationMs: finished - started });
  };
}

export function installNetworkPerformanceTrace() {
  if (typeof window === "undefined" || typeof window.fetch !== "function" || window.__zunoFetchTraced) return;
  window.__zunoFetchTraced = true;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const requestStarted = elapsed();
    const rawUrl = typeof input === "string" ? input : input?.url || "unknown";
    let endpoint = "unknown";
    try {
      const parsed = new URL(rawUrl, window.location.origin);
      endpoint = `${parsed.origin}${parsed.pathname}`;
    } catch (_) {}
    const method = String(init?.method || input?.method || "GET").toUpperCase();
    if (requestStarted <= 10000) markPerformance("REQUEST_START", { endpoint, method });
    try {
      const response = await originalFetch(input, init);
      if (requestStarted <= 10000) markPerformance("REQUEST_DONE", {
        endpoint, method, status: response.status, durationMs: elapsed() - requestStarted,
      });
      return response;
    } catch (error) {
      if (requestStarted <= 10000) markPerformance("REQUEST_ERROR", {
        endpoint, method, code: error?.code || error?.name || "unknown", durationMs: elapsed() - requestStarted,
      });
      throw error;
    }
  };
}

export function getPerformanceReport() {
  return [...events];
}

if (typeof window !== "undefined") {
  window.__ZUNO_PERFORMANCE__ = { getReport: getPerformanceReport };
}

markPerformance("APP_START", {}, { onlyOnce: true });
